import { useState } from "react";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SubscribeInline() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      return toast.error("Ingresa un correo válido");
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "footer" }),
      });
      if (!res.ok) throw new Error();
      setOk(true);
      toast.success("¡Gracias! Te suscribiste a FlexShade.");
    } catch {
      toast.error("Hubo un problema. Intenta más tarde.");
    } finally {
      setLoading(false);
    }
  };

  if (ok) {
    return (
      <div className="flex items-center gap-2 text-sm text-green-400" data-testid="subscribe-ok">
        <CheckCircle2 className="w-4 h-4" /> Suscripción confirmada.
      </div>
    );
  }

  return (
    <div data-testid="subscribe-footer">
      <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-3">Recibe novedades</h4>
      <p className="text-xs text-white/60 mb-3">Promos exclusivas, proyectos y tips FlexShade. Sin spam.</p>
      <form onSubmit={submit} className="flex gap-2">
        <div className="flex-1 relative">
          <Mail className="w-4 h-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="email"
            placeholder="tucorreo@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white/5 border border-white/15 text-white rounded-lg pl-9 pr-3 py-2.5 text-sm placeholder-white/40 focus:outline-none focus:border-orange-500"
            data-testid="subscribe-footer-email"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="btn-primary px-4 py-2.5 rounded-lg text-sm disabled:opacity-60"
          data-testid="subscribe-footer-submit"
        >
          {loading ? "..." : "Suscribirme"}
        </button>
      </form>
    </div>
  );
}
